module.exports = __webpack_public_path__ + "static/kid_with_yellow_cape_pretending_to_fly_in_front_of_pool-4bc90f7e61ac3396c7a70ab273322530.webp";